/**
 * @generated SignedSource<<1de5826acaf58d1b31dffa058b494eef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventPersonalCalendarInfo_eventParent$data = {
  readonly id: string;
  readonly externalEventId: string;
  readonly syncedOriginEventErrorable: {
    readonly __typename: "Event";
    readonly title: string | null;
  } | {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "EventPersonalCalendarInfo_eventParent";
};
export type EventPersonalCalendarInfo_eventParent$key = {
  readonly " $data"?: EventPersonalCalendarInfo_eventParent$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventPersonalCalendarInfo_eventParent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventPersonalCalendarInfo_eventParent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalEventId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "syncedOriginEventErrorable",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "type": "Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "type": "GraphEntityError",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventParent",
  "abstractKey": null
};
})();

(node as any).hash = "8e4902760d78eb16cfc142847a123f15";

export default node;
